import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TableColumn } from '../../../shared-components/data-table/data-table.component';
import { ChangelogDialogConfig } from '../../../shared-components/changelog-dialog/changelog-dialog.component';

@Component({
  selector: 'app-assessment-changelog',
  templateUrl: './assessment-changelog.component.html',
  standalone: false
})
export class AssessmentChangelogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any  ) {
    const columns: TableColumn[] = [
      { key: 'actionType', header: 'Action', formatter: (value) => this.formatActionType(value) },
      { key: 'factorStageAssessment', header: 'Stage Assessment', formatter: (value) => this.formatStage(value) },
      { key: 'isPriority', header: 'Priority', formatter: (value) => value ? 'Yes' : 'No' },
      { key: 'observations', header: 'Observations' },
      { key: 'recommendations', header: 'Recommendations' },
      { key: 'changedBy', header: 'Changed By' },
      {
        key: 'changedAtUtc',
        header: 'Changed At',
        formatter: (value) => this.formatDate(value)
      }
    ];

    const config: ChangelogDialogConfig = {
      title: 'Assessment Change Log',
      apiEndpoint: `api/osh/assessment/${data.assessmentId}/history`,
      columns: columns,
      backButtonText: 'Back'
    };

    Object.assign(this.data, config);
  }

  private formatDate(date: any): string {
    if (!date) return '-';
    const d = new Date(date);
    if (Number.isNaN(d.getTime())) return '-';
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
  }

  private formatActionType(type: string): string {
    const map: Record<string, string> = {
      INSERT: 'Created', UPDATE: 'Updated', DELETE: 'Deleted',
      ATTACHMENT: 'File Attached', ATTACH_DEL: 'File Deleted',
    };
    return map[type] ?? type;
  }

  private formatStage(stage: number | null): string {
    if (stage === null || stage === undefined) return '-';
    const stages = ['', 'Foundation', 'Demonstrating', 'Performing', 'Excelling'];
    return stages[stage] || stage.toString();
  }
}